import { FunctionComponent, useState } from 'react'
import { IForumSearchResultItem } from 'Frontend/scripts/models/forums.model'
import { Button } from 'react-bootstrap'
import AssignUser from './AssignUser'
import { useTranslation } from 'react-i18next'

interface UnassignedThreadProps {
  thread: IForumSearchResultItem
}

const ThreadItem: FunctionComponent<UnassignedThreadProps> = ({ thread }) => {
  const [showAssignableUsers, setShowAssignableUsers] = useState<boolean>(false)
  const { t } = useTranslation()

  return (
    <li className="d-flex justify-content-between position-relative manage-forums__thread-item">
      <a className="manage-forums__thread-item-link" href={thread?.url}>
        {thread?.title}
      </a>
      <Button
        variant={`${thread?.assignedUser != null ? 'link' : 'secondary'}`}
        className={`align-self-center ${thread?.assignedUser != null ? 'manage-forums__profile-button' : ''}`}
        size="sm"
        onClick={() => {
          setShowAssignableUsers(!showAssignableUsers)
        }}
      >
        {thread?.assignedUser != null ? (
          thread?.assignedUser?.profileImageUrl ? (
            <img
              className="manage-forums__user-profile-image"
              src={thread.assignedUser.profileImageUrl}
              alt={`${t('image-of')} ${thread?.assignedUser?.firstname} ${thread?.assignedUser?.lastname}`}
              title={`${t('owner')}: ${thread?.assignedUser.firstname} ${thread?.assignedUser.lastname}`}
            />
          ) : (
            <div
              className="manage-forums__user-initial-letters"
              title={`${t('owner')} ${thread.assignedUser?.firstname} ${thread.assignedUser?.lastname}`}
            >
              {thread.assignedUser?.firstname?.charAt(0)}
              {thread.assignedUser?.lastname?.charAt(0)}
            </div>
          )
        ) : (
          <>{t('assign')}</>
        )}
      </Button>
      <AssignUser
        isVisible={showAssignableUsers}
        threadId={thread.id}
        callback={(value: boolean) => setShowAssignableUsers(value)}
      />
    </li>
  )
}

export default ThreadItem
